module.exports = __webpack_public_path__ + "img/logo-levantek-350.9db291e4.png";